import { invokeRPC } from './socket.js'

export function getTimeFramesForProject(projectId) {
  return invokeRPC('time_frame', 'getTimeFramesForProject', { project_id: projectId })
}

export function getUsableTimeFramesForProject(projectId, checker) {
  return invokeRPC('time_frame', 'getUsableTimeFramesForProject', { project_id: projectId, checker })
}

export function syncTableauTimeFramesForProject(projectId, parameters) {
  return invokeRPC('time_frame', 'syncTableauTimeFramesForProject', {
    project_id: projectId,
    parameters
  })
}

export function getDateRange(dateRangeId) {
  return invokeRPC('time_frame', 'getDateRange', { date_range_id: dateRangeId })
}

export function deleteTimeFrame(timeFrameId) {
  return invokeRPC('time_frame', 'deleteTimeFrame', { time_frame_id: timeFrameId })
}

export function saveTableauDateRangeSettings(data) {
  return invokeRPC('time_frame', 'saveTableauDateRangeSettings', data)
}

export function updateTableauDateRangeSettings(data) {
  return invokeRPC('time_frame', 'updateTableauDateRangeSettings', data)
}

export function updateTableauFimeFrames(timeFrames) {
  return invokeRPC('time_frame', 'updateTableauTimeFrames', { timeFrames })
}

export function importTimeFrameFromTable(data) {
  return invokeRPC('time_frame', 'importTimeFrameFromTable', data)
}
